import axios from 'axios';
import { useEffect, useRef, useState } from 'react';

import { connect } from "react-redux";
import * as actions from './actions'
import AppConfig from './AppConfig.json'
import PinInput from 'react-pin-input';
import CloseButton from './CloseButton';
import "./PinProtectScreen.scss"
import { useHistory, withRouter } from 'react-router';

export function PinProtectScreen(props) {
    let [isAuthened, setIsAuthened] = useState()
    let [isMismatch, setIsMismatch] = useState(false)
    let history = useHistory()
    let pinInput = useRef()

    // useEffect(() => {
    //     if (window.location.href.includes("localhost"))
    //         setIsAuthened(true)
    // }, [])

    const pinValidate = async (pin) => {
        try {
            let result = await axios.post(`${AppConfig.endpoint}/member/pin/verify`, { pin }, {
                headers: {
                    "x-access-token": props.app.accessToken,
                    "x-api-key": AppConfig.api_key
                }
            })

            console.log(result)

            if (!result.error) {
                if (result.data.success) {
                    setIsAuthened(true)
                }
                else {
                    setIsMismatch(true)
                }
            }
            else {
                history.push("/member/error")
            }

        }
        catch (err) {
            history.push("/member/error")
            // setIsMismatch(true)
        }
    }

    return isAuthened ? props.children : <div className="edit-screen pin-auth-screen">
        <div className="has-text-right">
            <CloseButton onClick={() => props.onClose || history.push("/member/profile")} />
        </div>

        <div style={{ marginBottom: 20 }}>Enter your PIN</div>
        <PinInput
            ref={pinInput}
            length={6}
            initialValue=""
            secret
            onChange={(value, index) => { }}
            type="numeric"
            inputMode="number"
            style={{ borderRadius: 8 }}
            inputStyle={{
                height: 48,
                width: 40,
                borderRadius: 8,
                background: '#252525',
                border: 0,
                margin: 4,
                fontSize: 25,
                color: '#FFFFFF'

            }}
            inputFocusStyle={{ background: '#383838', border: 0 }}
            onComplete={(value, index) => {
                pinValidate(value)
                pinInput.current.clear()
            }}
            autoSelect={true}
            regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
        />

        {isMismatch && <div className="help has-text-danger">Input PIN is mismatch. Please Try Again.</div>}

        <div style={{ padding: 16 }}>
            <a href={AppConfig.url_app_info_update}>
                <div className="hint" style={{ background: 'transparent' }}>การอัพเดตอีเมล หรือเบอร์โทรศัพท์มือถือ จำเป็นต้องระบุ PIN เพื่อยืนยัน หากคุณไม่เคยตั้งค่า PIN มาก่อน สามารถตั้งค่าได้ใน <span className="blue"> The 1 Application</span></div>
            </a>
        </div>
    </div>
}

export default withRouter(connect((state) => state, actions)(PinProtectScreen))